// Config for marketing consent toggle on sign up
export const marketingConsentActivated = true;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl = 'https://freitag.ch/en_CH/service/smallprint';
